(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["formatees-respondio-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const setup = () => {
      const root = document.getElementById('formatees-ai');
      if (!root || root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const launcher = root.querySelector('[data-ai-launcher]');
      const intro = root.querySelector('#formatees-ai-intro');
      const close = root.querySelector('[data-ai-close]');
      const start = root.querySelector('[data-ai-start]');
      const showIntro = open => {
        intro.hidden = !open;
        launcher.setAttribute('aria-expanded', String(open));
        if (open) close.focus();
      };
      launcher.addEventListener('click', () => showIntro(intro.hidden));
      close.addEventListener('click', () => { showIntro(false); launcher.focus(); });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape') { showIntro(false); launcher.focus(); }
      });
      document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) showIntro(false); });
      start.addEventListener('click', () => {
        try { window.$respond.do('chat:open'); }
        catch { document.documentElement.classList.remove('formatees-ai-ready'); root.hidden = true; }
      });
      let attempts = 0;
      const attach = () => {
        const sdk = window.$respond;
        if (!sdk || typeof sdk.do !== 'function' || typeof sdk.on !== 'function' || typeof sdk.is !== 'function' || !document.querySelector('iframe[title="Webchat Widget"]')) return false;
        try {
          sdk.on('chat:opened', () => { showIntro(false); root.hidden = true; });
          sdk.on('chat:closed', () => { root.hidden = false; showIntro(false); launcher.focus(); });
          document.documentElement.classList.add('formatees-ai-ready');
          root.hidden = sdk.is('chat:open');
          return true;
        } catch { return false; }
      };
      if (attach()) return;
      const timer = window.setInterval(() => { attempts += 1; if (attach() || attempts >= 60) window.clearInterval(timer); }, 250);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["formatees-studio-entry"] && !Shopify.designMode) return;
  try {
    (() => {

    const init = entry => {
      if (entry.dataset.ready) return;
      entry.dataset.ready = 'true';
      const track = entry.querySelector('[data-studio-track]');
      const prev = entry.querySelector('[data-studio-prev]');
      const next = entry.querySelector('[data-studio-next]');
      const update = () => {
        prev.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({ left: direction * (track.clientWidth + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
      entry.addEventListener('click', event => {
        const link = event.target.closest('a[data-studio-open]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!window.HTMLDialogElement) return;
        const url = new URL(link.href);
        const dialog = document.querySelector('[data-fm-studio-dialog]');
        if (url.origin !== location.origin || !dialog) return;
        event.preventDefault();
        dialog.dispatchEvent(new CustomEvent('formatees:studio-open', { bubbles: true, detail: { model: url.searchParams.get('modelo') } }));
      });
    };
    document.querySelectorAll('[data-studio-entry]').forEach(init);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-studio-entry]').forEach(init));
  })();
  } catch(e) { console.error(e); }
})();

})();
